import { Pipe, PipeTransform } from '@angular/core';
import { RiskLevels } from 'src/app/feature/site-rediness-matrix/constants/enums';

@Pipe({
  name: 'riskLevel'
})

export class RiskLevelPipe implements PipeTransform {
  transform(value: number, ...args: any[]): string {
    return RiskLevels[value];
  }
}
